<template>
  <dialog-template v-model="isShownContent">
    <h3 :class="$style.title" slot="title">
      {{ $t('language.list.title') }}
    </h3>
    <div
      v-for="language in getPreparedLanguages"
      :key="language.id"
      :class="$style.panel"
      slot="content"
    >
      <selectabling-panel :item="language" @click="handleClickToLanguage">
        <country-flag :language-code="language.code" slot="icon" />
      </selectabling-panel>
    </div>
  </dialog-template>
</template>

<script>
import { mapGetters } from 'vuex';

import { getLanguages, getLocale } from 'services/project';

import CountryFlag from 'molecules/CountryFlag';
import SelectablingPanel from 'molecules/panels/SelectablingPanel';
import DialogTemplate from 'templates/DialogTemplate';

import { EVENT_BUS } from '@/eventBus';

export default {
  name: 'LanguagesListModal',
  components: {
    CountryFlag,
    SelectablingPanel,
    DialogTemplate,
  },
  props: {
    value: Boolean,
    currentLanguage: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.loadLanguages();
  },
  data() {
    return {
      isShownContent: false,
      languagesList: [],
    };
  },
  computed: {
    getPreparedLanguages() {
      return this.languagesList
        .map(language => {
          const isCurrent = language.code === this.currentLanguage.code;

          return {
            ...language,
            active: isCurrent,
            description: this.$t(language.description),
          };
        });
    },
    ...mapGetters(['getLocalization']),
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.isShownContent = val;
      },
    },
    isShownContent: {
      handler(val) {
        this.$emit('input', val);
        EVENT_BUS.$emit('show.languages', val);
      },
    },
  },
  methods: {
    async loadLanguages() {
      try {
        this.languagesList = await getLanguages();
      } catch (error) {
        console.error(error);
      }
    },
    async handleClickToLanguage(language) {
      try {
        const locale = await getLocale({ language: language.code });

        localStorage.setItem('lang', JSON.stringify(locale.language));
        EVENT_BUS.$emit('change.locale', locale.language);
      } catch (error) {
        console.log(error);
      }

      this.$nextTick(() => {
        this.isShownContent = false;
      });
    },
  },
};
</script>

<style lang="sass" module>
  .title
    +title-dialog
    color: #212121

  .panel
    &:not(:last-child)
      margin-bottom: 10px
</style>
